import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Metodi di pagamento abilitati", -1)
const _hoisted_3 = { class: "d-flex align-items-center mb-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Carta di credito ")
const _hoisted_5 = { class: "d-flex align-items-center mb-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Bonifico ")
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" PayPal ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = {
  key: 0,
  class: "col-sm-6"
}
const _hoisted_13 = {
  key: 1,
  class: "col-sm-6"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Riga 1 ricevuta footer", -1)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Riga 2 ricevuta footer", -1)
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Riga 3 ricevuta footer", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bonifico_config_details = _resolveComponent("bonifico-config-details")!
  const _component_stripe_config_details = _resolveComponent("stripe-config-details")!
  const _component_paypal_config_details = _resolveComponent("paypal-config-details")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checkBig mr-1",
            style: {"height":"30px"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.metodiPagamento) = $event)),
            value: 1
          }, null, 512), [
            [_vModelCheckbox, _ctx.localValue.metodiPagamento]
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checkBig mr-1",
            style: {"height":"30px"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.metodiPagamento) = $event)),
            value: 2
          }, null, 512), [
            [_vModelCheckbox, _ctx.localValue.metodiPagamento]
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "checkBig mr-1",
            style: {"height":"30px"},
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.metodiPagamento) = $event)),
            value: 9
          }, null, 512), [
            [_vModelCheckbox, _ctx.localValue.metodiPagamento]
          ]),
          _hoisted_8
        ])
      ])
    ]),
    _hoisted_9,
    (_ctx.localValue.metodiPagamento.some(x => x == 2))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_bonifico_config_details, {
            modelValue: _ctx.localValue.bonificoConfigDetails,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.bonificoConfigDetails) = $event))
          }, null, 8, ["modelValue"]),
          _hoisted_10
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.localValue.metodiPagamento.some(x => x == 1) || _ctx.localValue.metodiPagamento.some(x => x == 9))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_ctx.localValue.metodiPagamento.some(x => x == 1))
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_stripe_config_details, {
                  modelValue: _ctx.localValue.stripeConfigDetails,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.stripeConfigDetails) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.localValue.metodiPagamento.some(x => x == 9))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_paypal_config_details, {
                  modelValue: _ctx.localValue.payPalConfigDetails,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.payPalConfigDetails) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.rigaUnoRicevuta) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.rigaUnoRicevuta]
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localValue.rigaDueRicevuta) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.rigaDueRicevuta]
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localValue.rigaTreRicevuta) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.rigaTreRicevuta]
      ])
    ]),
    _hoisted_20
  ]))
}